import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  public requestAPIurl: any = environment.apiURL;
  public userId: string;
  public headers: any

  constructor(private http: HttpClient) { }

  setHeaders() {
    if (JSON.parse(sessionStorage.getItem('logged-in-user'))) {
      this.userId = JSON.parse(sessionStorage.getItem('logged-in-user'))._id;
      this.headers = new HttpHeaders().set('id', this.userId);
    }
  }

  createSubscription(body) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/v1/subscription`, body, { 'headers': this.headers });
  }

  cancelSubscription(subscriptionId, body) {
    return this.http.post(`${this.requestAPIurl}/v1/subscription/${subscriptionId}/cancel`, body, { 'headers': this.headers });
  }

  verifySubscriptionPayment(body) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/v1/subscription/verify`, body, { 'headers': this.headers });
  }

  getAllCatalogPlans() {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/v1/plan`, { 'headers': this.headers });
  }

  getSubscriptionForUser(userId: string) {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/v1/subscription/user/${userId}`, { 'headers': this.headers });
  }
}
